import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

// Logo URL - Served locally to avoid CDN cross-origin issues
const LOGO_URL = "/images/logo-rotary.png";

const StickyHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header 
      className={`sticky-header ${scrolled ? 'scrolled' : 'bg-white/90 backdrop-blur-sm'}`}
      data-testid="sticky-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[90px]">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="header-logo-link">
            <img
              src={LOGO_URL}
              alt="Rotary Club Zaragoza"
              className="h-20 sm:h-24 md:h-28 lg:h-32 w-auto object-contain"
              data-testid="header-logo"
            />
          </Link>

          {/* Desktop Navigation - Hidden on Mobile */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {[
              { path: "/", label: "Inicio" },
              { path: "/nuestro-club", label: "Nuestro Club" },
              { path: "/eventos", label: "Eventos" },
              { path: "/reloj-solar", label: "Reloj Solar" },
              { path: "/patrocinadores", label: "Patrocinadores" },
              { path: "/contacto", label: "Contacto" },
            ].map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-heading uppercase tracking-wider transition-colors ${
                  location.pathname === item.path
                    ? "text-[#013E7F] font-semibold"
                    : "text-slate-600 hover:text-[#013E7F]"
                }`}
                data-testid={`nav-desktop-${item.label.toLowerCase()}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Centenario Badge */}
          <div className="hidden lg:flex items-center gap-2 bg-[#013E7F]/5 px-4 py-2 rounded-full border border-[#013E7F]/20">
            <span className="w-2 h-2 bg-[#F7A81B] rounded-full animate-pulse" />
            <span className="text-xs font-heading text-[#013E7F] tracking-wider uppercase">
              Centenario 1925-2025
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default StickyHeader;
